<template>
  <div class="activity_evaluation content">
    <!-- <div class="score_top">
      <span>整体评分</span>
      <evaluation-star/>
    </div> -->
    <div class="score_content content_width">
      <pagination :data="list" @pagination="loadMore">
        <template slot-scope="scope">
          <evaluation-item v-for="evaluation in scope.data" :key="evaluation.id" :evaluation="evaluation"/>
        </template>
      </pagination>
    </div>
  </div>
</template>

<script>
// import evaluationStar from '@/components/activity/evaluation/star.vue'
import evaluationItem from '@/components/activity/evaluation/item.vue'
import pagination from '@/components/common/pagination.vue'
import { getActivityEvaluation } from '@/api/activity'

export default {
  name: 'activity-evaluation',
  props: ['activity'],
  data () {
    return {
      loading: false,
      hasMore: true,
      list: [],
      listQuery: {
        page: 1,
        limit: 10
      }
    }
  },
  components: {
    evaluationItem,
    pagination
  },
  created () {
    this.getEvaluations()
  },
  methods: {
    async getEvaluations () {
      this.loading = true
      let response = await getActivityEvaluation(this.activity.id, this.listQuery)

      if (this.listQuery.page === 1) {
        this.list = response.data.results
      } else {
        this.list = this.list.concat(response.data.results)
      }

      if (this.list.length >= response.data.count) {
        this.hasMore = false
      }

      this.loading = false
    },
    async loadMore () {
      if (this.loading || !this.hasMore) return false

      Indicator.open({ spinnerType: 'fading-circle' })
      this.listQuery.page += 1
      await this.getEvaluations()
      Indicator.close()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .activity_evaluation {
    /*padding-top: rem(20);*/
    .score_top {
      border-bottom: rem(1) solid #eeeeee;
      text-align: center;
      padding: rem(20);
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: #333;
        padding: 0 rem(10);
        font-size: rem(27);
      }
    }
    .score_content {
      padding: rem(25) 0;
      box-sizing: border-box;
      color: #000;
    }
  }
</style>
